<template>
  <div class="wrapper inline-grid grid-cols-9 col-gap width-full">
    <header class="page-title col-span-6 col-start-2">
      <h1 class="header-one">
        Background attachment
      </h1>
      <p class="page-title__sub">
        Utility classes for background attachments.
      </p>
    </header>
    <section class="section col-span-6 col-start-2">
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Class name</th>
              <th>Properties</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code class="code__class">.bg-fixed</code>
              </td>
              <td>
                <code class="code__prop">background-attachment: fixed;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.bg-scroll</code>
              </td>
              <td>
                <code class="code__prop">background-attachment: scroll;</code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Fixed
        </h2>
      </header>
      <p>
        <code>.bg-fixed</code> is used when you don't want the image to scroll
        with the page.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="bg-fixed..."&gt;&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview class="preview--fixed">
        <template #preview>
          <div class="preview__wrapper grid grid-cols-4 col-gap
          l-col-gap m-col-gap align-items-start width-full"
          >
            <div class="col-span-2 col-start-2 row-start-2 preview__image width-full">
              <span class="preview__image-large bg-no-repeat bg-fixed bg-cover width-full" />
            </div>
          </div>
        </template>
      </preview>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Scroll
        </h2>
      </header>
      <p>
        <code>.bg-scroll</code> is used when you  want the image to scroll
        with the page.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="bg-scroll..."&gt;&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview class="preview--fixed">
        <template #preview>
          <div class="preview__wrapper grid grid-cols-4 col-gap
          l-col-gap m-col-gap align-items-start width-full"
          >
            <div class="col-span-2 col-start-2 row-start-2 preview__image width-full">
              <span class="preview__image-large bg-no-repeat bg-scroll bg-cover width-full" />
            </div>
          </div>
        </template>
      </preview>
    </section>
  </div>
</template>

<script>
import Preview from '@/components/Preview';
import CodeBlock from '@/components/Code-Block';

export default {
  name: 'BgAttachment',
  components: {
    Preview,
    CodeBlock,
  },
};
</script>
